import React, { Component } from 'react';

import {Dropdown, Menu, Modal} from 'antd';

import utils from './../utils/';
import Fetch from './../services/fetch';

const menu = (change) => (
    <Menu onClick={({key}) => {
        change(key);
    }}>
        <Menu.Item key="1">关闭标签</Menu.Item>
        <Menu.Item key="2">关闭其他标签</Menu.Item>
        <Menu.Item key="3">关闭右侧标签</Menu.Item>
        <Menu.Item key="4">关闭全部标签</Menu.Item>
    </Menu>
);

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
    }
    
    componentDidMount() {
        const url = window.location.hash;
        this.findMenuActive(this.props.session.rules, url.replace('#', ''));
        if(this.tab) {  
            this.props.insertOrUpdateTab(this.tab);
        }
    }

    findMenuActive(rules, url) {
        for(var i = 0; i < rules.length; i++) {
            if(rules[i].url === url) {
                this.tab = rules[i];
                break;
            } else if(rules[i].children) {
                this.findMenuActive(rules[i].children || [], url);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        let tab = {};
        for(var i = 0; i < nextProps.tabs.length; i++) {
            if(nextProps.tabs[i].active === true) {
                tab = nextProps.tabs[i];
                break;
            }
        }
        if(tab.url &&  window.location.hash !== tab.url) {
            if(/insert/.test(window.location.hash) === false 
            && /update/.test(window.location.hash) === false 
            && /publish/.test(window.location.hash) === false 
            // && /detail/.test(window.location.hash) === false 
            && /comment/.test(window.location.hash) === false
            ) {
                window.location.hash = tab.url.replace('#', '')
            } else{
                window.location.hash = window.location.hash.toLowerCase();
            }
        }
    }

    handleChange(tab) {
        this.props.names.forEach(name => {
            if(tab.url.indexOf(name) !== -1) {
                this.props.setCache({
                    [name]: true,
                });
                return;
            }
        });
        this.props.insertOrUpdateTab(tab); 
    }

    handleClose(tab) {
        this.props.removeTab(tab);

        this.props.names.forEach(name => {
            if(tab.url.indexOf(name) !== -1) {
                this.props.setCache({
                    [name]: false,
                });
                return;
            }
        });

        utils.removeKeywords('#' +tab.url);
        Fetch.removeModelByKey(tab.url);
        
        if(this.props.tabs.length === 1) {
            window.location.hash = '/';
        }
    }

    dropdownChange(index, key){

        if(key === '1') {
            const tab = this.props.tabs[index];
            this.handleClose(tab);
        } else if(key === '2') {
            this.props.tabs.forEach((tab, i) => {
                ((tab, i) => {
                    if(index !== i) {
                        setTimeout(() =>{
                            this.handleClose(tab);
                        }, 100 + i * 10);
                    }
                })(tab, i);
            })
        } else if(key === '3') {
            this.props.tabs.forEach((tab, i) => {
                
                ((tab, i) => {
                    if(index < i) {
                        setTimeout(() =>{
                            this.handleClose(tab);
                        }, 100 + i * 10);
                    }
                })(tab, i);
            })
        } else if(key === '4') {
            this.props.tabs.forEach((tab, i) => {
                ((tab, i) => {
                    setTimeout(() =>{
                        this.handleClose(tab);
                    }, 100 + i * 10);
                })(tab, i);
            });
            
            setTimeout(() =>{
                this.handleClose(tab);
            }, 100 + this.props.tabs.length * 10 + 5);
            window.location.hash = '/';
        }
    }

    render() {
        const tabs = this.props.tabs;
        return (
            <div class="root-breadcrumb">
                <ul>
                {
                    tabs.map((tab, index) => (
                        <li title={tab.name}>
                        <Dropdown overlay={menu((key) => {
                                this.dropdownChange(index, key);
                            })} trigger={['contextMenu']}>
                            <span className={tab.active ? "tab-panel-active" : 'tab-panel-default'}>
                            <a href={"#"+ tab.url} className={tab.active ? "tab-active" : 'tab-default'} onClick={this.handleChange.bind(this, tab)}>
                                {tab.name}
                            </a> 
                            
                            <i onClick={this.handleClose.bind(this, tab)}>
                            <svg width="10" height="10">
                                <path stroke="#555" d="M0,0L10,10M0,10L10,0"></path>
                            </svg>
                            </i>
                            </span>
                        </Dropdown>
                        </li>
                    ))
                }
                </ul>
            </div>
        )
    }
}

export default Breadcrumb;